import React from "react";
import { createWagmiProvider } from "@layerzerolabs/x-trader-joe-bridge";
import { wagmi } from "./config/wagmi";

const EthereumAdapterProvider = createWagmiProvider(
  wagmi
) as React.FC<React.PropsWithChildren>;

export default EthereumAdapterProvider;
